export default "__VITE_ASSET__BNYm9LVN__"